export default __webpack_public_path__ + "static/media/intro_04.8274fc81.png";